import { ElasticChangeView } from "@mark43/cad-api";
import { ChangeViewDisplayName } from "./types";

export function extractChangeValues(keys: ChangeViewDisplayName[], changeViews?: ElasticChangeView[]) {
    const result = {} as Record<ChangeViewDisplayName, string>;
    keys.forEach(key => {
        result[key] = '-';
    });

    if (!changeViews) {
        return result;
    }

    for (const item of changeViews) {
        const displayName = item.displayName as ChangeViewDisplayName;
        if (displayName && keys.includes(displayName)) {
            result[displayName] = item.newValue ?? '-';
        }
    }

    return result;
}
